import { defineComponent as n, openBlock as o, createBlock as r, unref as a, mergeProps as c, withCtx as p, createElementVNode as i } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconStarOutlined",
  __name: "IconStarOutlined",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const t = l;
    return (u, e) => (o(), r(a(d), c(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        i("path", {
          "fill-rule": "evenodd",
          d: "M10.846 3.65c.427-1.026 1.881-1.026 2.308 0l2.008 4.827 5.21.418c1.108.089 1.558 1.472.713 2.195l-3.97 3.4 1.213 5.085c.258 1.082-.918 1.937-1.867 1.357L12 18.208l-4.461 2.724c-.949.58-2.126-.275-1.868-1.357l1.213-5.084-3.97-3.4C2.07 10.366 2.52 8.983 3.628 8.894l5.21-.418 2.008-4.826M12 4.783l-1.835 4.412A1.25 1.25 0 0 1 9.11 9.96l-4.763.382 3.63 3.109a1.25 1.25 0 0 1 .402 1.24L7.27 19.338l4.078-2.491a1.25 1.25 0 0 1 1.303 0l4.079 2.49-1.109-4.648a1.25 1.25 0 0 1 .403-1.24l3.63-3.108-4.765-.382a1.25 1.25 0 0 1-1.054-.766L12 4.782",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
